import './Footer.component.css'
import React from "react";

function Footer() {
	return (
		<div className="footer">
			<div>DIAMONDS</div>
		</div>
	);
}

export default Footer;